import React from 'react'
import { css } from '@emotion/core'
import { boolAttr } from '@fs/zion-frontend-friends'
import useIsMobile from '../hooks/useIsMobile'

const detailsContainerCss = css`
  margin: 0 auto;
  max-width: 1100px;
  &[is-mobile] {
    padding: 24px;
  }
`

export default function DetailsPageContainer({ children }) {
  const isMobile = useIsMobile()
  return (
    <div is-mobile={boolAttr(isMobile)} css={detailsContainerCss}>
      {children}
    </div>
  )
}
